export default {
  primary: {
    main: "#05a",
    light: "#1565c0"
  }
};
//# sourceMappingURL=darkBlue.js.map